export const UserRole = {
  SuperAdmin: "super-admin",
  DistributorAdmin: "distributor-admin",
  SalesRep: "sales-rep",
  BrandAdmin: "brand-admin",
  ImporterAdmin: "importer-admin",
};
